import * as React from "react";

export enum PUBLIC_PATHS {
  WELCOME = "/",
  LOGIN = "/login",
  VERIFY = "/verify",
  VERIFY_SECONDARY_EMAIL = "/verify-secondary-email",
  FORGOT_PASSWORD = "/forgot-password",
  FORGOT_PASSWORD_SUCCESS = "/forgot-password-success",
  VERIFY_FORGOT_PASSWORD = "/verify-forgot-password",
  FILL_FORGOT_PASSWORD = "/fill-forgot-password",
  PASSWORD_SETUP = "/password-setup",
  PASSWORD_SETUP_SUCCESS = "/password-setup-success",
  DOCUMENT_SIGNING_REDIRECT = "/docusign-callback",
  PROPERTY_DOCUSIGN_CALLBACK = "/property/:propertyId/docusign-callback",
  NOT_FOUND = "/not-found",
}

export const publicRoutes = [
  {
    key: "Welcome",
    path: PUBLIC_PATHS.WELCOME,
    component: React.lazy(() => import("../views/auth/welcome")),
  },
  {
    key: "Login",
    path: PUBLIC_PATHS.LOGIN,
    component: React.lazy(() => import("../views/auth/login")),
  },
  {
    key: "Verify",
    path: PUBLIC_PATHS.VERIFY,
    component: React.lazy(() => import("../views/auth/verifyEmail")),
  },
  {
    key: "Verify Secondary Email",
    path: PUBLIC_PATHS.VERIFY_SECONDARY_EMAIL,
    component: React.lazy(() => import("../views/auth/verifySecondaryEmail")),
  },
  {
    key: "Password Setup",
    path: PUBLIC_PATHS.PASSWORD_SETUP,
    component: React.lazy(() => import("../views/auth/passwordSetup")),
  },
  {
    key: "Password Setup Success",
    path: PUBLIC_PATHS.PASSWORD_SETUP_SUCCESS,
    component: React.lazy(() => import("../views/auth/passwordSetupSuccess")),
  },
  {
    key: "Forgot Password",
    path: PUBLIC_PATHS.FORGOT_PASSWORD,
    component: React.lazy(() => import("../views/auth/forgotPassword")),
  },
  {
    key: "Verify Forgot Password",
    path: PUBLIC_PATHS.VERIFY_FORGOT_PASSWORD,
    component: React.lazy(() => import("../views/auth/verifyForgotPassword")),
  },
  {
    key: "Fill Forgot Password",
    path: PUBLIC_PATHS.FILL_FORGOT_PASSWORD,
    component: React.lazy(() => import("../views/auth/fillForgotPassword")),
  },
  {
    key: "Forgot Password Success",
    path: PUBLIC_PATHS.FORGOT_PASSWORD_SUCCESS,
    component: React.lazy(() => import("../views/auth/forgotPasswordSuccess")),
  },
  {
    key: "Document Signing Error",
    path: PUBLIC_PATHS.DOCUMENT_SIGNING_REDIRECT,
    component: React.lazy(() => import("../views/documentSigningRedirect")),
  },
  {
    key: "Property Docusign Callback",
    path: PUBLIC_PATHS.PROPERTY_DOCUSIGN_CALLBACK,
    component: React.lazy(() => import("../views/propertyDocusignCallback")),
  },
  {
    key: "Organization Not Found",
    path: PUBLIC_PATHS.NOT_FOUND,
    component: React.lazy(() => import("../views/notFound")),
  },
];
